import React from "react";
import classNames from "classnames";
import { Props, Layout } from "./types";
import styles from "./styles.scss";

function isEqual(current: Layout, next: Layout): boolean {
  return (
    current.x === next.x &&
    current.y === next.y &&
    current.width === next.width &&
    current.height === next.height &&
    current.top === next.top &&
    current.right === next.right &&
    current.bottom === next.bottom &&
    current.left === next.left
  );
}

function LayoutWatcher(props: Props) {
  const ref = React.useRef<HTMLDivElement>(null);
  const [layout, setLayout] = React.useState<Layout>({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  });

  React.useEffect(() => {
    if (ref.current) {
      const nextLayout = ref.current.getBoundingClientRect();

      !isEqual(layout, nextLayout) && setLayout(nextLayout);
    }
  }, [layout]);

  return (
    <div
      ref={ref}
      className={classNames(styles.layoutWatcher, {
        [props.className || ""]: props.className,
      })}
    >
      {props.renderChildren(layout)}
    </div>
  );
}

export { LayoutWatcher };
